import React, {useEffect} from "react";

import Modal from '@material-ui/core/Modal';

import FormHelperText from '@material-ui/core/FormHelperText';

import InputLabel from '@material-ui/core/InputLabel';
import MenuItem from '@material-ui/core/MenuItem';
import FormControl from '@material-ui/core/FormControl';
import Select from '@material-ui/core/Select';

import Button from "@material-ui/core/Button";
import PersonAddIcon from "@material-ui/icons/PersonAdd";
import {CircularProgress, Grid} from "@material-ui/core";
import {useHistory, useParams} from "react-router-dom";
import {generateDynamicRoute} from "../../../utils/utils";
import {AdminUtilisateursModifierGroupePage} from "../../../routes/administratorRoutes";
import {
    adminUtilisateursFetchGroupeListeGroupes, adminUtilisateursFetchGroupeListeUtilisateurs,
    adminUtilisateursFetchListeGroupes
} from "../../../store/actions/admin/utilisateurs/listeGroupesActions";

import {connect} from "react-redux";
import Chip from "@material-ui/core/Chip";


import FormControlLabel from '@material-ui/core/FormControlLabel';
import Switch from '@material-ui/core/Switch';



import DateFnsUtils from '@date-io/date-fns';

import {
    DateTimePicker,
    MuiPickersUtilsProvider,
} from '@material-ui/pickers';
import {
    adminAssignementsGroupeCoursAjouterAssignementGroupeCours,
    adminAssignementsGroupeCoursAjouterAssignementGroupeCoursReset
} from "../../../store/actions/admin/assignementsGroupeCours/ajouterAssignementGroupeCoursActions";
import Alert from "@material-ui/lab/Alert";
import ExpansionPanel from "@material-ui/core/ExpansionPanel";
import ExpansionPanelSummary from "@material-ui/core/ExpansionPanelSummary";
import ExpandMoreIcon from "@material-ui/icons/ExpandMore";
import ExpansionPanelDetails from "@material-ui/core/ExpansionPanelDetails";
import TreeListeGroupesSingleAdd from "../../../components/TreeListeGroupesSingleAdd";
import Box from "@material-ui/core/Box";
import TreeListeGroupesMultiAdd from "../../../components/TreeListeGroupesMultiAdd";
import {adminCoursFetchListeCours} from "../../../store/actions/admin/cours/listeCoursActions";
import TreeListe from "../../../components/TreeListe";
import {
    adminCoursFetchCategorieListeCategories, adminCoursFetchCategorieListeCours,
    adminCoursFetchListeCategories
} from "../../../store/actions/admin/cours/listeCategoriesActions";

const initialState = {
    groupe: {value : null, error : null},
    cours: {value : null, error : null},
    role: {value : null, error : null} ,
    dateDebutEnabled : false,
    dateDebut : new Date(),
    dateFinEnabled : false,
    dateFin : new Date(),
    groupesExpanded : false,
    coursExpanded : false
};

function AjouterAssignementGroupeCoursModal(props) {


    const history = useHistory();

    let { groupeId } = useParams();

    const handleGroupesExpanded = (event,isExpanded) => {
        setState(prevState => {
            return {
                ...prevState,
                groupesExpanded : isExpanded
            }
        });
    };

    const handleCoursExpanded = (event,isExpanded) => {
        setState(prevState => {
            return {
                ...prevState,
                coursExpanded : isExpanded
            }
        });
    };

    useEffect(() => {

        if(props.groupe.groupe) {
            setState(prevState => {
                return {
                    ...prevState,
                    groupe:{ value : props.groupe.groupe, error : null}
                }
            })
        }

    },[props.groupe.groupe]);


    useEffect(() => {
        props.fetchListeGroupes();
        props.fetchListeCours();
        props.fetchListeCategories();

        return () => {
            props.ajouterAssignementGroupeCoursReset();
        }

    },[]);

    const [state, setState] = React.useState(initialState);

    const handleDateDebutChange = (date) => {
        setState(prevState => {
            return {
                ...prevState,
                dateDebut : date
            }
        })
    };
    const handleDateFinChange = (date) => {
        setState(prevState => {
            return {
                ...prevState,
                dateFin: date
            }
        })
    };

    const handleChangeRole = (event) => {
        const value = event.target.value;
        setState(prevState => {
            return {
                ...prevState,
                role : {value: value, error:null}
            }
        })
    };

    const handleChangeDateDebutEnabled = (event) => {
        const checked = event.target.checked;
        setState(prevState => {
            return {
                ...prevState,
                dateDebutEnabled: checked
            }
        });
    };

    const handleChangeDateFinEnabled = (event) => {
        const checked = event.target.checked;
        setState(prevState => {
            return {
                ...prevState,
                dateFinEnabled: checked
            }
        });
    };



    const handleClose = () => {

        history.push(generateDynamicRoute(AdminUtilisateursModifierGroupePage.path,[{toReplace:":groupeId",value:groupeId}]));

    };

    const formOnSubmitHandler = (event) => {

        event.preventDefault();

        let error = false;

        const groupe = state.groupe.value;
        const cours = state.cours.value;
        const role = state.role.value;

        if(!groupe) {
            error = true;
            setState(prevState => {
                return {
                    ...prevState,
                    groupe: {
                        value: null,
                        error : "Le groupe est obligatoire"
                    }
                }
            })
        }

        if(!cours) {
            error = true;
            setState(prevState => {
                return {
                    ...prevState,
                    cours: {
                        value: null,
                        error : "Le cours est obligatoire"
                    }
                }
            })
        }

        if(!role) {
            error = true;
            setState(prevState => {
                return {
                    ...prevState,
                    role: {
                        value: null,
                        error : "Le role est obligatoire"
                    }
                }
            })
        }

        if(!error) {

            const assignementGroupeCours = {
                groupe : {
                    id : groupe.id
                },
                cours : {
                    id : cours.id
                },
                role : role,
                dateDebut : state.dateDebutEnabled ? state.dateDebut : null,
                dateFin : state.dateFinEnabled ? state.dateFin : null
            };


            props.ajouterAssignementGroupeCours(assignementGroupeCours);
        }

    };

    const handleGroupeSelect = (groupe) => {
        setState(prevState => {
            return {
                ...prevState,
                groupe: {value : groupe, error : null }
            };
        });
    };

    const handleGroupeUnSelect = () => {
        setState(prevState => {
            return {
                ...prevState,
                groupe: {value : null, error : null }
            };
        });
    };



    const handleCoursSelect = (cours) => {
        setState(prevState => {
            return {
                ...prevState,
                cours:{value : cours, error : null}
            };
        });
    };

    const handleCoursUnSelect = () => {
        setState(prevState => {
            return {
                ...prevState,
                cours: {value: null, error :null}
            };
        });
    };

    const isCoursSelected = (coursToCheck) => {
        return state.cours.value && state.cours.value.id === coursToCheck.id;
    };


    const isGroupeSelected = (groupeToCheck) => {
        return state.groupe.value && state.groupe.value.id === groupeToCheck.id;
    };


    return(
        <Modal
            open={true}
            onClose={handleClose}
            style={{overflowY:"auto"}}
        >
            <div style={{maxWidth:"700px", width:"100%"}} className={"bg-white text-center border rounded mx-auto my-5"}>

                <h2>Assigner un groupe à un cours</h2>

                {props.assignementGroupeCours.error &&
                <Alert className={"mt-2 mb-3"} variant="filled" severity="error">{props.assignementGroupeCours.error}</Alert>
                }
                {props.assignementGroupeCours.success&&
                <Alert className={"mt-2 mb-3"} variant="filled" severity="success">L'assignement ajouté avec succees</Alert>
                }


                <MuiPickersUtilsProvider utils={DateFnsUtils}>
                <form className={"text-left p-4"} onSubmit={formOnSubmitHandler}>


                        <ExpansionPanel expanded={state.groupesExpanded} onChange={handleGroupesExpanded}>
                            <ExpansionPanelSummary
                                expandIcon={<ExpandMoreIcon />}
                            >
                                <FormControl error={state.groupe.error ? true : false}>
                                <h6>Groupe : {!state.groupesExpanded && state.groupe.value ? <Chip label={state.groupe.value.nom} onDelete={handleGroupeUnSelect} /> : null}</h6>
                                    {state.groupe.error && <FormHelperText>{state.groupe.error}</FormHelperText>}
                                </FormControl>

                            </ExpansionPanelSummary>
                            <ExpansionPanelDetails >
                                {props.listeGroupes.loading ?
                                    <CircularProgress size={50} thickness={4} />
                                    :
                                    <Grid container spacing={3}>

                                        <Grid item xs={12} md={8} >
                                            <span>Selectionner un groupe</span>

                                            <TreeListe fetchGroupeListeGroupes={props.fetchGroupeListeGroupes} selectable={"Groupe"} liste={props.listeGroupes.listeGroupes} onlyGroupes={true} handleSelect={handleGroupeSelect} handleUnSelect={handleGroupeUnSelect} isGroupeSelected={isGroupeSelected}/>

                                        </Grid>
                                        <Grid item xs={12} md={4} >
                                            <span>Groupe Selectionné</span>
                                            <Box>
                                                {state.groupe.value &&
                                                <Chip
                                                    label={state.groupe.value.nom}
                                                    onDelete={handleGroupeUnSelect}
                                                />}
                                            </Box>
                                        </Grid>

                                    </Grid>
                                }
                            </ExpansionPanelDetails>
                        </ExpansionPanel>




                    <ExpansionPanel expanded={state.coursExpanded} onChange={handleCoursExpanded}>
                        <ExpansionPanelSummary
                            expandIcon={<ExpandMoreIcon />}
                        >
                            <FormControl error={state.cours.error ? true : false}>
                                <h6>Cours : {!state.coursExpanded && state.cours.value ? <Chip label={state.cours.value.titre} onDelete={handleCoursUnSelect} /> : null}</h6>
                                {state.cours.error && <FormHelperText>{state.cours.error}</FormHelperText>}
                            </FormControl>
                            </ExpansionPanelSummary>
                        <ExpansionPanelDetails >
                            {props.listeCours.loading ?
                                <CircularProgress size={50} thickness={4} />
                                :
                                <Grid container spacing={3}>

                                    <Grid item xs={12} md={8} >
                                        <span>Selectionner un cours</span>
                                        <TreeListe fetchCategorieListeCategories={props.fetchCategorieListeCategories} fetchCategorieListeCours={props.fetchCategorieListeCours} selectable={"Cours"} liste={props.listeCategories.listeCategories.concat(props.listeCours.listeCours)} handleSelect={handleCoursSelect} handleUnSelect={handleCoursUnSelect} isCoursSelected={isCoursSelected}/>
                                    </Grid>
                                    <Grid item xs={12} md={4} >
                                        <span>Cours Selectionné</span>
                                        <Box>
                                            {state.cours.value &&
                                            <Chip
                                                label={state.cours.value.titre}
                                                onDelete={handleCoursUnSelect}
                                            />}
                                        </Box>
                                    </Grid>

                                </Grid>
                            }
                        </ExpansionPanelDetails>
                    </ExpansionPanel>



                    <FormControl error={state.role.error ? true : false} fullWidth={true} className={"my-3"}>
                        <InputLabel id="demo-simple-select-label">Role</InputLabel>
                        <Select
                            labelId="demo-simple-select-label"
                            id="demo-simple-select"
                            value={state.role.value}
                            onChange={handleChangeRole}
                        >
                            <MenuItem value={'ROLE_APPRENANT'}>Apprenant</MenuItem>
                            <MenuItem value={'ROLE_ENSEIGNANT'}>Enseignant</MenuItem>
                        </Select>
                        {state.role.error && <FormHelperText>{state.role.error}</FormHelperText>}
                    </FormControl>


                    <FormControlLabel
                        control={<Switch checked={state.dateDebutEnabled} onChange={handleChangeDateDebutEnabled} />}
                        label="Avoir un date debut"
                    />

                    <br />
                    <DateTimePicker value={state.dateDebut}
                                    fullWidth={true}
                                    label="Date Debut"
                                    disabled={!state.dateDebutEnabled}
                                    disablePast
                                    ampm={false}
                                    format="yyyy/MM/dd HH:mm" inputVariant={"outlined"} onChange={handleDateDebutChange} />

                    <FormControlLabel
                        control={<Switch checked={state.dateFinEnabled} onChange={handleChangeDateFinEnabled} />}
                        label="Avoir un date fin"
                    />

                    <DateTimePicker value={state.dateDebut}
                                    fullWidth={true}
                                    label="Date Debut"
                                    disabled={!state.dateFinEnabled}
                                    disablePast
                                    ampm={false}
                                    format="yyyy/MM/dd HH:mm" inputVariant={"outlined"} onChange={handleDateFinChange} />

                                    <div>
                                        <Button disabled={props.assignementGroupeCours.loading} type={"submit"} className={"my-2"}
                                                color={"primary"} variant={"contained"} endIcon={<PersonAddIcon/>}>Ajouter</Button>
                                        {props.assignementGroupeCours.loading && <CircularProgress size={24} /*className={spinnerClasses.join(" ")}*/ />}
                                    </div>

                </form>
                </MuiPickersUtilsProvider>


            </div>
        </Modal>
    );




}

const mapStateToProps = (state) => {
    return {
        assignementGroupeCours : state.admin.assignementsGroupeCours.ajouterAssignementGroupeCours,
        groupe : state.admin.utilisateurs.groupe,
        listeGroupes : state.admin.utilisateurs.listeGroupes,
        listeCours : state.admin.cours.listeCours,
        listeCategories : state.admin.cours.listeCategories
    }
};

const mapDispatchToProps = (dispatch) => {
    return {
        ajouterAssignementGroupeCours : (assignementGroupeCours) => dispatch(adminAssignementsGroupeCoursAjouterAssignementGroupeCours(assignementGroupeCours)),
        ajouterAssignementGroupeCoursReset : () => dispatch(adminAssignementsGroupeCoursAjouterAssignementGroupeCoursReset()),
        fetchListeGroupes : () => dispatch(adminUtilisateursFetchListeGroupes()),
        fetchGroupeListeGroupes : (groupeId) => dispatch(adminUtilisateursFetchGroupeListeGroupes(groupeId)),

        fetchListeCategories : () => dispatch(adminCoursFetchListeCategories()),
        fetchCategorieListeCategories : (categorieId) => dispatch(adminCoursFetchCategorieListeCategories(categorieId)),
        fetchCategorieListeCours : (categorieId) => dispatch(adminCoursFetchCategorieListeCours(categorieId)),

        fetchListeCours : () => dispatch(adminCoursFetchListeCours()),
    }
};

export default connect(mapStateToProps,mapDispatchToProps)(AjouterAssignementGroupeCoursModal);